<template>
  <the-mask
    class="form-control"
    v-model="dataVal"
    :value="model"
    :mask="mask"
    :required="required"
    :disabled="disabled"
    maxlength="20"
    :placeholder="placeholder"
    @blur="blurDefault"
    @input="inputDefault"
  />
</template>

<script>
export default {
  props: {
    value: null,
    input: { type: Function, default: null },
    blur: { type: Function, default: null },
    cpf: { type: Boolean, default: false },
    cnpj: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pesquisaDocumento: { type: Boolean, default: false },
    placeholder: { default: '' }
  },

  data () {
    return {
      dataVal: this.value
    }
  },

  computed: {
    mask () {
      const masks = []

      // CNPJ alfanumérico
      if (!this.cpf || this.cnpj) {
        masks.push('XX.XXX.XXX/XXXX-XX')
      }

      // CPF numérico
      if (!this.cnpj || this.cpf) {
        masks.push('###.###.###-##')
      }

      return masks
    },

    model: {
      get () {
        return this.value
      },
      set () {}
    }
  },

  watch: {
    model (newValue) {
      this.dataVal = newValue
      this.inputDefault(newValue)
    }
  },

  methods: {
    DocumentoFederal (value) {
      if (!value) return value

      // CPF → apenas números
      if (this.cpf && !this.cnpj) {
        const numeric = value.toString().replace(/\D/g, '')

        if (numeric.length === 11) {
          return numeric.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            '$1.$2.$3-$4'
          )
        }

        return numeric
      }

      // CNPJ → alfanumérico
      if (this.cnpj) {
        const alfanum = value
          .toString()
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '')

        if (alfanum.length === 14) {
          return alfanum.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            '$1.$2.$3/$4-$5'
          )
        }

        return alfanum
      }

      return value
    },

    inputDefault (val) {
      const formatted = this.DocumentoFederal(val)
      this.$emit('input', formatted)

      if (this.input) {
        this.input(formatted)
      }
    },

    blurDefault () {
      if (this.blur) {
        this.blur()
      }
    }
  }
}
</script>